




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Restaurant } from '../Restaurant';
import Incredient from './Incredient.vue';
import AccordionItem from './AccordionItem.vue';
import { getFavouriteRestaurants, addFavouriteRestaurant, removeFavouriteRestaurant, fetchLuchMenu, FoodMenu, formatDateTime, formatDate, isToday } from "../utils";



@Component<RestaurantInfo>({
	components: {
		Incredient,
		AccordionItem,
	},
	watch: {
		loadMenu: function (newVal, oldVal) {
			if (!oldVal && newVal) {
				this.updateMenuData();
			}
		}
	}
})
export default class RestaurantInfo extends Vue {

	//@ts-ignore
	@Prop() restaurant: Restaurant;
	//@ts-ignore
	@Prop() loadMenu: boolean;
	//@ts-ignore
	@Prop() forceMenuLoad: boolean;

	private lunchMenu: FoodMenu[] = [];
	private lunchTime = "";
	// Initialised to "" (not undefined) so vue-class-component makes them reactive.
	private menuUpdatedAt = "";
	private menuDate = "";
	private title = "";
	private hasMenu = true;
	private hasTime = true;
	private isLoading = true;
	private isFavourite = false;

	/**
	 * Vue created hook.
	 */
	public created(): void {
		this.title = this.restaurant.title
		let restaurants = getFavouriteRestaurants();
		let filteredRestaurants = restaurants.filter(restaurant => restaurant.address === this.restaurant.address);
		if (filteredRestaurants.length > 0) {
			this.isFavourite = true;
		}
		if (this.forceMenuLoad) {
			this.updateMenuData();
		}
	}

	/**
	 * Fetches and updates the restaurant info.
	 */
	private updateMenuData(): void {
		if (this.restaurant.lunchUrl) {
			fetchLuchMenu(this.restaurant.lunchUrl, this.restaurant).then(menu => {
				this.isLoading = false;
				this.lunchMenu = menu.lunchMenu;
				this.lunchTime = menu.lunchTime;
				this.menuUpdatedAt = menu.updatedAt;
				this.menuDate = menu.menuDate;
				this.hasMenu = menu.hasMenu;
				this.hasTime = menu.hasTime;
				if (menu.title) {
					this.title = menu.title;
				}
			});
		} else {
			this.isLoading = false;
			this.hasMenu = false;
			this.hasTime = false;
		}
	}

	/**
	 * Handles favourite button click.
	 */
	private handleFavourite(): void {
		if (this.isFavourite) {
			removeFavouriteRestaurant(this.restaurant);
		} else {
			addFavouriteRestaurant(this.restaurant);
		}
		this.isFavourite = !this.isFavourite;
	}

	// Imported functions aren't reachable from the template, so expose them as methods.
	private formatDateTime(iso: string): string {
		return formatDateTime(iso);
	}

	private formatDate(isoDate: string): string {
		return formatDate(isoDate);
	}

	private isToday(isoDate: string): boolean {
		return isToday(isoDate);
	}

}
